import {
  Table,
  TableRow,
  TableCell,
  Paragraph,
  TextRun,
  WidthType,
  VerticalAlign,
} from "docx";

export function ModelWorldShtojca3(tableContent) {
  const docSections = [];

  const getTotalPerMedia = (data) => {
    const totals = {};
    data.forEach((row) => {
      Object.entries(row).forEach(([key, value]) => {
        if (key !== "Institucionet") {
          const num = parseFloat(value);
          totals[key] = (totals[key] || 0) + (isNaN(num) ? 0 : num);
        }
      });
    });
    return totals;
  };

  const formatNumber = (num) => Number(num).toFixed(2);

  const totals = getTotalPerMedia(tableContent);
  const mediaNames = Object.keys(totals);

  const firstTabelLables = ["RTSH 1", "KlanTv", "Top Channel", "Vizion Plus"];
  const secondTableLabels = mediaNames.filter(
    (item) => !firstTabelLables.includes(item)
  );

  const renderTable = (medias) => {
    const rows = [];

    const temaColumnWidth = 30;
    const remainingWidth = 100 - temaColumnWidth;
    const cellWidth = remainingWidth / (medias.length * 2);

    // Header row 1
    const headerRow1 = new TableRow({
      height: { value: 900 },
      children: [
        new TableCell({
          margins: {
            top: 10, // në twips (1/20 i pikës, 100 = 5pt)
            bottom: 10,
            left: 40, // 200 = 10pt
            right: 40,
          },
          rowSpan: 1,
          children: [
            new Paragraph({
              children: [
                new TextRun({
                  text: "Institucionet / OSHMA",
                  color: "FFFFFF",
                  size: 24,
                }),
              ],
            }),
          ],
          verticalAlign: VerticalAlign.CENTER,
          shading: { fill: "ED1D25" },
          width: { size: temaColumnWidth, type: WidthType.PERCENTAGE },
        }),
        ...medias.map(
          (media) =>
            new TableCell({
              margins: {
                top: 10, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 10,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: media,
                      color: "FFFFFF",
                      size: 24,
                    }),
                  ],
                  alignment: "center",
                }),
              ],
              verticalAlign: VerticalAlign.CENTER,
              shading: { fill: "ED1D25" },
              columnSpan: 2,
            })
        ),
      ],
    });

    // Header row 2
    const headerRow2 = new TableRow({
      height: { value: 400 },
      children: [
        new TableCell({
          children: [new Paragraph({})],
          shading: { fill: "D9D9D9" },
          width: { size: temaColumnWidth, type: WidthType.PERCENTAGE },
        }),
        ...medias.flatMap(() => [
          new TableCell({
            margins: {
              top: 10, // në twips (1/20 i pikës, 100 = 5pt)
              bottom: 10,
              left: 40, // 200 = 10pt
              right: 40,
            },
            children: [
              new Paragraph({
                children: [new TextRun({ text: "Min", size: 20 })],
                alignment: "center",
              }),
            ],
            shading: { fill: "D9D9D9" },
            width: { size: cellWidth, type: WidthType.PERCENTAGE },
            verticalAlign: VerticalAlign.CENTER,
          }),
          new TableCell({
            margins: {
              top: 10, // në twips (1/20 i pikës, 100 = 5pt)
              bottom: 10,
              left: 40, // 200 = 10pt
              right: 40,
            },
            children: [
              new Paragraph({
                children: [new TextRun({ text: "%", size: 20 })],
                alignment: "center",
              }),
            ],
            shading: { fill: "D9D9D9" },
            width: { size: cellWidth, type: WidthType.PERCENTAGE },
            verticalAlign: VerticalAlign.CENTER,
          }),
        ]),
      ],
    });

    rows.push(headerRow1, headerRow2);

    // Body
    tableContent.forEach((row) => {
      rows.push(
        new TableRow({
          height: { value: 400 },
          children: [
            new TableCell({
              margins: {
                top: 10, // në twips (1/20 i pikës, 100 = 5pt)
                bottom: 10,
                left: 40, // 200 = 10pt
                right: 40,
              },
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: row["Institucionet"],
                      bold: false,
                      size: 20,
                    }),
                  ],
                }),
              ],
              width: { size: temaColumnWidth, type: WidthType.PERCENTAGE },
              verticalAlign: VerticalAlign.CENTER,
            }),
            ...medias.flatMap((media) => {
              const minutes = parseFloat(row[media] || "0");
              const percent =
                totals[media] > 0 ? (minutes / totals[media]) * 100 : 0;
              return [
                new TableCell({
                  margins: {
                    top: 10, // në twips (1/20 i pikës, 100 = 5pt)
                    bottom: 10,
                    left: 40, // 200 = 10pt
                    right: 40,
                  },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: formatNumber(minutes),
                          size: 20,
                        }),
                      ],
                      alignment: "center",
                    }),
                  ],
                  width: { size: cellWidth, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                }),
                new TableCell({
                  margins: {
                    top: 10, // në twips (1/20 i pikës, 100 = 5pt)
                    bottom: 10,
                    left: 40, // 200 = 10pt
                    right: 40,
                  },
                  children: [
                    new Paragraph({
                      children: [
                        new TextRun({
                          text: formatNumber(percent) + "%",
                          size: 20,
                        }),
                      ],
                      alignment: "center",
                    }),
                  ],
                  width: { size: cellWidth, type: WidthType.PERCENTAGE },
                  verticalAlign: VerticalAlign.CENTER,
                }),
              ];
            }),
          ],
        })
      );
    });

    return new Table({
      rows,
      width: { size: 100, type: WidthType.PERCENTAGE },
    });
  };

  docSections.push(renderTable(firstTabelLables));
  docSections.push(
    new Paragraph({
      children: [new TextRun({ text: "", size: 1 })],
      spacing: { after: 400 },
    })
  );
  docSections.push(renderTable(secondTableLabels));

  return docSections;
}
